/** Public site links — keep social URLs in sync with marketing. */
export const SOCIAL_LINKS = [
    {
        id: "instagram",
        label: "Instagram",
        href: "https://www.instagram.com/jmalinuk/",
    },
    {
        id: "x",
        label: "X (Twitter)",
        href: "https://x.com/jmalinuk",
    },
    {
        id: "linkedin",
        label: "LinkedIn",
        href: "https://www.linkedin.com/in/jmalinuk/",
    },
    {
        id: "youtube",
        label: "YouTube",
        href: "https://www.youtube.com/@fairshareuk",
    },
];

export const LEGAL_NAV_LINKS = [
    { to: "/terms", label: "Terms & conditions" },
    { to: "/privacy", label: "Privacy policy" },
];
